import {
    ConnectionRequestSchema,
    type ConnectionRequestType,
    type ConnectionResponseType,
} from './types';
import { extractFieldsFromB } from '../../utilities/SchemaManager';

export class Connection {
    private _connection: ConnectionResponseType | null;
    private _innerId: string;

    constructor() {
        this._innerId = Math.random().toString(36).substring(7);
        this._connection = null;
    }

    public setRequest(request: ConnectionRequestType): this {
        // @ts-ignore -- missing id
        this._connection = request;
        return this;
    }

    public getRequest(): ConnectionRequestType {
        if (!this._connection) {
            throw new Error('Connection not set');
        }
        let request = extractFieldsFromB<ConnectionRequestType>(
            this._connection,
            ConnectionRequestSchema
        );
        return request;
    }

    public set(c: ConnectionResponseType): this {
        this._connection = c;
        return this;
    }

    public get innerId(): string {
        return this._innerId;
    }

    public get id(): number | null {
        return this._connection?.id || null;
    }

    public getData(): ConnectionResponseType | null {
        return this._connection;
    }
}
